import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../../components/builders/loader/loader.component';
import { ImageSliderComponent } from '../../image-slider/image-slider.component';

@Component({
  selector: 'app-customer-view-profile',
  templateUrl: './customer-view-profile.component.html',
  styleUrls: ['./customer-view-profile.component.scss']
})
export class CustomerViewProfileComponent implements OnInit {
  @ViewChild('alertModal')
  public alertModal: any;
  headers: any = [];
  values: any = [];
  allValues: any = [];
  modifiedData: any = [];
  data: any[];
  allHeaders = [];
  empID: any = ""
  id = "";
  profileId = ""
  LoaderComponent: any = '';
  primaryObject: any = {};
  aboutObject:any ="";
  paymentForm: FormGroup;
  profileIdInputValue: any = "";
  isLoading: any = false;
  printData: any =[];
  printMyProfileBasicData: any = [];
  alertMessage: any = "";
  profileDataImages: any = [];
  glleryClicked: boolean = false;
  loginData: any;
  constructor(private actRoute: ActivatedRoute, private dataStore: Data, public dialog: MatDialog, public service: WebRequestService,) { }

  ngOnInit(): void {
    this.dataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
    })
    .catch((err) => console.error(err));
    this.paymentForm = new FormGroup({
      profileId: new FormControl('',[Validators.required ,Validators.pattern(/^[0-9\s]*$/)])
    })
  }
  omit_specialChar_and_char(event) {
    let x = event.which || event.keycode;
    if ((x >= 48 && x <= 57))
      return true;
    else
      return false;
  }
  onChange(e){
    const item = e.target.value.replace(/\D/g,'')
    this.paymentForm.patchValue({'profileId': item})
  }
  captureInputValue(event: any) {
    this.profileIdInputValue += event.target.value
  }
  submitProfileId(id, empID?) {
    if (id != '') {
      this.empID = empID == 0 ? empID : sessionStorage.getItem('empId');
      this.LoaderComponent = LoaderComponent;
      this.service.viewProfile(id, this.empID).then((response) => {
        this.modifiedData = [];
        this.printData = [];
        this.printMyProfileBasicData = [];
        this.aboutObject = ""
        if (response['statusCode'] === 200) {
          const trackingActivityData = {
            Application: 'E',
            RoleId: this.loginData['empTypeID'],
            Event: 'On submit of profile',
            Module: 'Registration',
            ProfileId: id ? id : null,
            EventOutcomeIndicator: 'In customer new admin profile, profile search',
            IPAddress: this.loginData.ipAddress
          };
          this.service.getActivityTracking(trackingActivityData).then((res) => {
            console.log(res);
          });
          this.LoaderComponent = "";
          this.isLoading = true;
          this.allValues = response['result'];
          for (let i = 1; i < response['result'].length; i++) {
            let arr = []
            let tableName = ""
            for (let j = 0; j < response['result'][i].length; j++) {
              let eachObject = {}
              if (response['result'][i][j]['TableName'] === response['result'][i][j]['TableName']) {
                tableName = response['result'][i][j]['TableName']
                if (response['result'][i][j]['columnname'] != null &&
                  response['result'][i][j]['value'] != "") {
                  eachObject['columnname'] = response['result'][i][j]['columnname']
                  eachObject['value'] = response['result'][i][j]['value']
                  if(eachObject['columnname'] === 'Property'){
                    let tempPropertyString = eachObject['value']; 
                    eachObject['value'] = this.converLakhsToCrores(tempPropertyString);
                  }
                }
                if (tableName === "Primary") {
                  this.primaryObject = response['result'][i][j]
                }
                if(tableName === "About"){
                  if(response['result'][i][j]['Aboutyourself']!=null && response['result'][i][j]['Aboutyourself']!='' && 
                  response['result'][i][j]['Aboutyourself']!='NOT Given'){
                    this.aboutObject = response['result'][i][j]
                  }
                } 

              }
              if (Object.keys(eachObject).length > 0 && eachObject.constructor === Object) {
                arr.push(eachObject)
              }
            }
            if (tableName != "" && arr.length > 0) {
              this.modifiedData.push({ key: tableName, data: arr })
              if(tableName==='My Basic Details' ){
                this.printMyProfileBasicData = arr
              } else{
                this.printData.push({ key: tableName, data: arr })
              }
            }
          }
          this.populateHeaders(response['result']);
          
        } else {
          this.LoaderComponent = ""
          this.alertMessage = response['message'];
          this.alertModal.show()
          setTimeout(() => {
            this.alertModal.hide();
          }, 5000);
        }

      })

    }else{
      this.alertMessage = "Please enter ProfileId";
      this.alertModal.show()
      setTimeout(() => {
        this.alertModal.hide();
      }, 5000);
    }
    

  }
  populateHeaders(headersData) {
    this.headers = [];
    for (let header of headersData[0]) {
      if (header['Headings'] != "") {
        this.headers.push(header['Headings'])
      }
    }
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  print() {

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
    <link rel="stylesheet" href=""  crossorigin="anonymous">
      <style>
      .col-md-1 {width:8%;  float:left;}
      .col-md-2 {width:16%; float:left;}
      .col-md-3 {width:25%; float:left;}
      .col-md-4 {width:33%; float:left;}
      .col-md-5 {width:42%; float:left;}
      .col-md-6 {width:50%; float:left;}
      .col-md-7 {width:58%; float:left;}
      .col-md-8 {width:66%; float:left;}
      .col-md-9 {width:75%; float:left;}
      .col-md-10{width:83%; float:left;}
      .col-md-11{width:92%; float:left;}
      .col-md-12{width:100%; float:left;}
      .ka-em-print-value{
        padding-top: 3% !important
      }
      .ka-em-print-screen-data{
        padding-top: 10% !important
      }
      .ka-em-border{
        border : 1px solid black
      }

      .watermark-bg {
        background-image: url(../../../../assets/img/printbg.PNG) !important;
        background-size: cover;
      }
      </style>
    </head>
<body class="watermark-bg" onload="window.print();window.close()">${printContents}</body>
  </html>`
    );
    popupWin.document.close();

  }


  naviagteToHoroscope() {
    if (this.primaryObject['HoroscopeImage'] != null) {
      window.open(`${this.primaryObject['HoroscopeImage']}`, '_blank');

    }
  }

  requestViewPhoto(id) {
    const custID = id;
    let dialogRef = this.dialog.open(ImageSliderComponent, {
      width: '500px',
      // height: '551px',
      data: { custID: custID}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  closeModalPreviewImage(data) {
    this.glleryClicked = false;
  }


  converLakhsToCrores(propertyString){
    let convertedPropertyString: any;
    let extractedDigits: any;
    const digitPattern = /\d+/g;
    const matches = propertyString.match(digitPattern);
    if (matches) {
      extractedDigits = matches.join('');
    } else {
      extractedDigits = ''; 
    }
    convertedPropertyString =  this.propertyLakhsToCroresConversion(extractedDigits);
    let returnValue: any;
    returnValue = this.reconstructString(convertedPropertyString,propertyString);
    return returnValue;
  }

  propertyLakhsToCroresConversion(extractedDigits){ 
    let tempPropertyValue: number = parseInt(extractedDigits);
    let covertedString: any;
    if(tempPropertyValue < 100){
      if(tempPropertyValue === 1)
         covertedString =  tempPropertyValue+' Lakh';
      else
        covertedString =  tempPropertyValue+' Lakhs';
    }      
    else{
      let covertedValue = tempPropertyValue / 100;
      if(covertedValue === 1){
        covertedString = covertedValue+' Crore';
      }
      else
      covertedString = covertedValue+' Crores';
    }
    return covertedString;
  }

  reconstructString(convertedPropertyString,originalString) {
    let reconstructedString: any;
    const lakhsPattern = /(\d+) Lakhs/;
    const match = originalString.match(lakhsPattern);
    if (match)
      reconstructedString = originalString.replace(lakhsPattern,convertedPropertyString);
    return reconstructedString;
  }


}
